import { render, staticRenderFns } from "./CodecoRawEventStatusChip.vue?vue&type=template&id=cf80a5f4"
import script from "./CodecoRawEventStatusChip.vue?vue&type=script&lang=js"
export * from "./CodecoRawEventStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports